import GridTile from "../grid/GridTile";
import Sprite from "./Sprite";
import TileDamageSpriteSeries from "./TileDamageSpriteSeries";

export default class TileDamageSpriteOverlay {
    constructor() {
        /**
         * @private
         * @constant
         * @type {TileDamageSpriteSeries[]} spriteSeries
         */
        this.spriteSeries = [];

    }

    /**
     * @param {TileDamageSpriteSeries} spriteSeries 
     */
    add(spriteSeries) {
        this.spriteSeries.push(spriteSeries);
    }

    /**
     * 
     * @param {GridTile} tile 
     * @returns {Sprite}
     */
    getDamageSprite(tile) {
        if (!tile || tile.open) {
            return null;
        }

        const healthPercent = tile.healthPercent;
        if (healthPercent === 100) {
            return null;
        }

        // We always want to use the same damage series for a tile, use the hash of the tile origin to choose the series.
        const index = Math.abs(tile.hash() % this.spriteSeries.length);
        return this.spriteSeries[index].getDamageSprite(healthPercent);
    }
}